import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Icon from '../AppIcon';
import Image from '../AppImage';
import Button from './Button';

const QRCodeLabel = ({ serialNumber, itemName, onClose }) => {
  const labelRef = useRef(null);



  const handleDirectPrint = () => {
    window.print();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-foreground/40 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-card rounded-lg border border-border elevation-3 w-full max-w-md animate-in fade-in zoom-in duration-200">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground">Print QR Code Label</h3>
          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-muted transition-smooth touch-target"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Label Preview */}
        <div className="p-6">
          <div
            ref={labelRef}
            className="print-label bg-white border-2 border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center justify-center space-y-4"
            style={{ minHeight: '400px' }}
          >
            {/* LaSea Logo */}
            <div className="w-28 h-14 flex items-center justify-center">
              <Image
                src="/assets/images/LaSea_Group_logo-1765111940679.png"
                alt="LaSea Group Logo"
                className="w-full h-full object-contain"
              />
            </div>

            {/* QR Code */}
            <div className="bg-white p-3 rounded-lg border border-gray-200">
              <QRCodeSVG
                value={serialNumber}
                size={150}
                level="H"
                includeMargin={true}
              />
            </div>

            {/* Serial Number */}
            <div className="text-center space-y-1 w-full">
              <p className="text-xs font-medium text-gray-600 uppercase tracking-wide">Serial Number</p>
              <code className="block text-xs font-mono font-bold text-gray-900 break-all px-2" style={{ wordBreak: 'break-all' }}>
                {serialNumber}
              </code>
            </div>

            {/* Item Name */}
            {itemName && (
              <div className="text-center w-full">
                <p className="text-xs font-medium text-gray-700 px-2">{itemName}</p>
              </div>
            )}
          </div>

          {/* Print Instructions */}
          <div className="mt-4 p-3 bg-muted rounded-lg">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs text-muted-foreground">
                Click Print to open the print dialog. You can print directly or save as PDF from there.
              </p>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3 p-4 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            fullWidth
          >
            Cancel
          </Button>

          <Button
            variant="default"
            onClick={handleDirectPrint}
            iconName="Printer"
            iconPosition="left"
            iconSize={16}
            fullWidth
          >
            Print
          </Button>
        </div>
      </div>

      {/* Print-specific styles */}
      <style>{`
        @media print {
          @page {
            size: letter;
            margin: 10mm;
          }
          body * {
            visibility: hidden;
          }
          .print-label, .print-label * {
            visibility: visible;
          }
          .print-label {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            max-width: 100%;
            page-break-inside: avoid;
          }
        }
      `}</style>
    </div>
  );
};

export default QRCodeLabel;